import { getAxiosInstance } from '../api.client';
import {
    AuthStatus,
    SetPasswordRequest,
    SetPasswordResponse,
} from './auth.models';

export async function getAuthStatus(): Promise<AuthStatus> {
    const response = await getAxiosInstance().get<AuthStatus>('/Auth/status');
    return response.data;
}

/**
 * Validates a registration token
 * @param token The encrypted token from the invitation link
 * @returns Promise that resolves if token is valid, rejects with 410 if expired, 403 if invalid
 */
export async function validateRegistrationToken(token: string): Promise<void> {
    const response = await getAxiosInstance().get<void>(
        `/auth/registration/validate`,
        {
            params: { token },
        },
    );
    return response.data;
}

/**
 * Sets a password for an account using an encrypted token
 * @param data The set password request data (password, token)
 * @returns The set password response
 */
export async function setPassword(
    data: SetPasswordRequest,
): Promise<SetPasswordResponse> {
    const response = await getAxiosInstance().post<SetPasswordResponse>(
        '/auth/registration/set-password',
        {
            password: data.password,
            token: data.token,
        },
    );
    return response.data;
}
